import { render, staticRenderFns } from "./payment-links.vue?vue&type=template&id=6aa5134b&scoped=true&"
import script from "./payment-links.vue?vue&type=script&lang=js&"
export * from "./payment-links.vue?vue&type=script&lang=js&"
import style0 from "./payment-links.vue?vue&type=style&index=0&id=6aa5134b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa5134b",
  null
  
)

export default component.exports